import { Box, Text, useBoolean } from '@chakra-ui/react';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import AppColors from '../../../constants/AppColors';
import { DepartmentIcon } from '../../../constants/IconData';
import { FONT_FAMILY } from '../../../constants/Theme';
import { useState } from 'react';

const SpecialtySelect = ({  options, placeholder, onInputChange }) => {
    const [cmsWarning, setCmsWarning] = useState(null);
    const [isLoading, ilState] = useBoolean(false)

    const formatOptionLabel = props => {
        return (
            <Box>
                <Text fontFamily={FONT_FAMILY.ptSans} fontSize="sm">
                    {props.label}
                    <span
                        style={{ fontSize: 10, color: AppColors.darkGray, marginLeft: 5 }}
                    >
                        {props.address}
                    </span>
                </Text>
            </Box>
        );
    };

    const NoOptionsMessage = props => {
        return (
            <components.NoOptionsMessage {...props}>
                <span className="custom-css-class">{props.selectProps.inputValue ? 'We don’t currently offer your specialty' : 'No options'}</span>
            </components.NoOptionsMessage>
        );
    };

    return <Box px={2}> <AsyncSelect
        name="department_name"
        id="department_name"
        formatOptionLabel={formatOptionLabel}
        isLoading={isLoading}
        // instead of calling the backend for every input change, we use autocomplete on the given options. It decreases useless backend calls
        loadOptions={(inputValue, callback) => 
            Promise.resolve(options.filter(option =>
                option.label.toLowerCase().startsWith(inputValue.toLowerCase())
            ))
        }
        cacheOptions
        defaultOptions={options ? options : []}
        onChange={async (newValue) => {
            await onInputChange(newValue, setCmsWarning, ilState);
        }}
        styles={{
            noOptionsMessage: (provided, state) => ({
                ...provided,
                backgroundColor: 'white',
            }),
            menu: props => ({
                ...props,
                zIndex: 10,
            }),
        }}
        components={{
            Control: ({ children, ...props }) => {
                return (
                    <components.Control {...props}>
                        <span style={{ marginLeft: 10 }}>
                            <DepartmentIcon style={{ height: 20, width: 20 }} />
                        </span>
                        {children}
                    </components.Control>
                );
            },
            NoOptionsMessage: NoOptionsMessage
        }}
        placeholder={placeholder ? "Search dept. name" : placeholder}
    />
    {(cmsWarning && !isLoading) && (
        <p style={{ color: cmsWarning.colour ?? (cmsWarning.isError ? 'red' : 'green') }}>
        {cmsWarning?.msg}
        </p>
    )}
    
    </Box>
}
export default SpecialtySelect